import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {InteractionPageComponent} from './interaction-page.component';
import {InteractionCustomComponent} from '../interaction-custom/interaction-custom.component';


const routes: Routes = [
 {
    path: ':type/:slug',
    component: InteractionPageComponent
  },
  {
    path: '',
    redirectTo: '/',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InteractionPageRoutingModule {
}
